import { OnInit, Component, Inject, Optional } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';
import { NxiContextUtils } from '@pershing/nxi-common';
import { DomainContext } from '@pershing/pershing-core';

@Component({
    selector: 'advisor-group-component',
    templateUrl: './advisor-group-component.html'
})

export class AdvisorGroupPerformanceComponent implements OnInit {
    appSettings: any;
    challengeURL: string;
    timeStamp: string;
    signedValue: string;
    userRefNum: string;
    title: string;
    acctRef: any;
    inputValue: any;
    launchURL: string;
    partnerID: string;
    width: string;
    height: string;
    AG_GROUPDISCLAIMER2: string;
    AG_GROUPDISCLAIMER3: string;
    AG_GROUPDISCLAIMER4: string;
    frameBorder: string;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any,
                private sanitizer: DomSanitizer) {
                    this.appSettings = appSettings;
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
        this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.widgetsParamService();
        });
        this.title = this.nxiWidgetParamsService.getTranslatedMessage('SSOOUT.QPRENVESTNETTITLE');
    }

    widgetsParamService() {
        this.nxiWidgetParamsService.getWidgetParam('/commonrest/ssoout?url=performance-popup').subscribe(
            resp => {
                if (resp.response) {
                    this.partnerID = resp.response.partnerID;
                    this.width = resp.response.width;
                    this.height = resp.response.height;
                    this.frameBorder = resp.response.frameBorder;
                    this.launchURL = resp.response.launchURL;
                }
            }
        );
        this.translationService.get('SSOOUT.AG_GROUPDISCLAIMER2').subscribe(
            res => {
                 this.AG_GROUPDISCLAIMER2 = res.replace ('{0}', this.appSettings.ibdConfigMap.ibdName);
                });
        this.translationService.get('SSOOUT.AG_GROUPDISCLAIMER3').subscribe(
            res => {
                 this.AG_GROUPDISCLAIMER3 = res.replace ('{0}', this.appSettings.ibdConfigMap.ibdName);
                });
        this.translationService.get('SSOOUT.AG_GROUPDISCLAIMER4').subscribe(
            res => {
                 this.AG_GROUPDISCLAIMER4 = res.replace ('{0}', this.appSettings.ibdConfigMap.ibdName);
                });
    }

    openNewWindow() {
        // window.open( this.launchURL + '?SSOIndicator=' + this.partnerID + '&&acctId=' + this.inputValue + ' ,_parent', 'name=SSOOUT class=noScroll width=' +
        //             this.width + ' height=' + this.height + ' frameborder=' + this.frameBorder);
        if (this.launchURL !== '') {
            let url = this.launchURL.split('/');
            let getURL = url[ url.length - 4 ] + '/' + url[ url.length - 3 ] + '/' + url[ url.length - 2 ] + '/' + url[ url.length - 1 ];
            window.open(getURL + '?SSOIndicator=' + this.partnerID + '&acctId=' + this.acctRef, '_blank', 'name=SSOOUT class=noScroll width=' +
                    this.width + 'height=' + this.height + 'frameborder=' + this.frameBorder);
        }
    }

}
